const withBase = (baseUrl, p) => {
    if (!p) return "";
    if (/^https?:\/\//i.test(p)) return p;
    const slash = p.startsWith("/") ? "" : "/";
    return `${baseUrl}${slash}${p}`;
};

export const toImageUrl = (img, baseUrl) => {
    if (!img) return "";
    if (typeof img === "string") return /^https?:\/\//i.test(img) ? img : withBase(baseUrl, img);

    if (img.url)   return /^https?:\/\//i.test(img.url)   ? img.url   : withBase(baseUrl, img.url);
    if (img.src)   return /^https?:\/\//i.test(img.src)   ? img.src   : withBase(baseUrl, img.src);
    if (img.path)  return withBase(baseUrl, img.path);
    if (img.imageUrl) return /^https?:\/\//i.test(img.imageUrl) ? img.imageUrl : withBase(baseUrl, img.imageUrl);

    if (img.Location) return img.Location;
    if (img.Key && img.bucketUrl) return `${img.bucketUrl.replace(/\/$/, "")}/${img.Key}`;

    return "";
};

export const normalizeServerImagesToStrings = (items = [], baseUrl = "") =>
    items.map(it => toImageUrl(it, baseUrl)).filter(Boolean);
